import React, { useEffect, useState } from "react";
import axios from "axios";
// material-ui
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import ButtonBase from "@material-ui/core/ButtonBase";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";

//icons
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

// app components
import { usePouchDB } from "../../../components/PouchDB/PouchDBProvider";
import AppPageLoading from "../../../components/AppPageLoading";
//utils
//import uuidv1 from 'uuid/v1';
// styles
import useStyles from "./styles";

// images
import kb from "../../../images/kb.png";

//utils
import qs from "query-string";
import { Link, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { FormControl, Select, MenuItem } from "@material-ui/core";

function Draft({ history, match, location }) {
  const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
  const db_name = localStorage.getItem("db_name");
  const remote_base = localStorage.getItem("remote_base");
  const url = remote_base + "/" + db_name;
  const url_split = remote_base ? remote_base.split("/") : "";
  const couchdb = url_split[url_split.length - 1];

  const classes = useStyles();
  const {
    user: { metadata },
    dataKK,
    dataKB,
    dataPK,
    dataBkkbn,
  } = usePouchDB();
  const [dataBkkbnDocs, setDataBkkbnDocs] = useState([]);
  const [isFetching, setFetching] = useState(true);
  const [isDeleting, setDeleting] = useState(false);
  const [kepalaKels, setKepalaKels] = useState([]);
  const [status, setStatus] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [statusSensus, setStatusSensus] = useState("");
  const params = useParams();
  const [didCancel, setDidCancel] = useState(false);
  const [forDelete, setDelete] = useState("");
  const [open, setOpen] = React.useState(false);
  const NEW_URL = process.env.REACT_APP_API_CONFIG_URL_NEW;
  const [lock, setLock] = useState(localStorage.getItem("lock"));

  const getAllDataBkkbn = async () => {
    setFetching(true);
    try {
      const query = await dataBkkbn.local.find({
        selector: {
          user_name: { $eq: metadata.name },
          // status_draft: { $eq: '1'}
        },
      });

      const newDocs = [];
      query.docs.reverse().forEach((item) => {
        if (item.status_sensus != "Delete") {
          if (item.status_draft && item.status_draft === "1") {
            newDocs.push(item);
          }
        }
      });

      if (!didCancel) {
        setDataBkkbnDocs(newDocs);
      }
    } catch (e) {}
    if (!didCancel) {
      setFetching(false);
    }
  };

  useEffect(() => {
    getAllDataBkkbn();

    return () => {
      setDidCancel(true);
    };
  }, []);

  useEffect(() => {
    const queryParams = qs.parse(location.search);
    let kepalas = dataBkkbnDocs
      .filter((kkDoc) => typeof kkDoc.data_nik !== "undefined")
      .map((kkDoc) => {
        let findKepala = kkDoc.data_nik.find(
          (data_nik) => data_nik.sts_hubungan
        );
        if (!findKepala) {
          findKepala = kkDoc.data_nik[0];
        }
        return {
          ...findKepala,
          // no_kk: kkDoc.no_kk,
          status_sensus: kkDoc.status_sensus,
          _id: kkDoc._id,
        };
      });

    setStatus(status);

    if (queryParams.query) {
      kepalas = kepalas.filter((kepala) => {
        // return kepala.nama_anggotakel.toLowerCase().includes(queryParams.query.toLowerCase());
        if (kepala.nama_anggotakel !== undefined) {
          return kepala.nama_anggotakel
            .toLowerCase()
            .includes(queryParams.query.toLowerCase());
        }
      });
    }

    setKepalaKels(kepalas);
  }, [dataBkkbnDocs, location.search]);

  const handleClose = () => {
    setOpen(false);
    setDelete("");
  };

  const deleteKel = (_id) => async (e) => {
    // if (!window.confirm("Kamu yakin ingin menghapus data ini?")) {
    //     return false
    // }
    setDeleting(true);
    setDelete("");
    setOpen(false);
    try {
      //remove from local
      const kkDoc = await dataBkkbn.local.get(_id);

      let os = window.navigator.userAgent; //get Browser and Os Version
      let time = new Date()
        .toLocaleString()
        .replace(",", "")
        .replace(/:.. /, " ");
      const audit_trail = "Delete Draft From " + os + " At " + time;
      let status = false;

      let dataLocal = {
        ...kkDoc,
        audit_trail,
        group: "dataBkkbn",
        status_sensus: "Delete",
      };
      const deleteData = {
        ...kkDoc,
        audit_trail,
        flag_retrieve: "",
        cfm: "false",
        location: { locationUser: [{ latitude: 0, longitude: 0 }] },
        status_sensus: "Delete",
      };

      try {
        await axios
          .post(NEW_URL + "pk/api/v1/save", deleteData, {
            headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
          })
          .then(() => (status = true));
      } catch (error) {
        console.error("Error saat menghapus data:", error);
      }

      try {
        // const data_selector = {
        //   selector: {
        //     _id: _id,
        //   },
        //   limit: 10000,
        // };
        // const kkDocRemote = await dataBkkbn.remote.get(_id);
        // const idkec = metadata?.wil_kecamatan?.id_kecamatan;
        // const kkDocRemote = await axios.post(
        //   url +
        //     "/_find?couchdb=" +
        //     couchdb +
        //     "&database-name=" +
        //     db_name +
        //     "&idKec=" +
        //     idkec,
        //   data_selector,
        //   {
        //     // headers: { user_key: USER_KEY_PG }
        //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        //   }
        // );
        // const new_doc = kkDocRemote.data[0];
        // let data = {
        //   ...new_doc,
        //   audit_trail,
        //   group: "dataBkkbn",
        //   status_sensus: "Delete",
        // };
        // await dataBkkbn['remote'].put(data);
        // await axios.put(
        //   url +
        //     "/" +
        //     _id +
        //     "/_put?couchdb=" +
        //     couchdb +
        //     "&database-name=" +
        //     db_name +
        //     "&_id=" +
        //     _id +
        //     "&idKec=" +
        //     metadata?.wil_kecamatan?.id_kecamatan,
        //   data,
        //   {
        //     // headers: { user_key: USER_KEY_PG }
        //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        //   }
        // );
        await dataBkkbn["local"].put(dataLocal);
      } catch (error) {
        console.log("e => ", error);

        if (error.message == "deleted") {
          await dataBkkbn["local"].put(dataLocal);
          status = true;
        }

        //await dataBkkbn.local.put({ ...kkDoc, _deleted: true });
      }

      console.log("status => ", status);

      if (status) {
        // const kbQuery = await dataBkkbn.local.find({
        //     selector: {
        //         _id: { $eq: _id }
        //     }
        // })
        // if (kbQuery.docs.length > 0)
        //     await dataBkkbn.local.bulkDocs(kbQuery.docs.map(doc => ({ ...doc, _deleted: true })))

        // const pkQuery = await dataBkkbn.local.find({
        //     selector: {
        //         _id: { $eq: _id }
        //     }
        // })
        // if (pkQuery.docs.length > 0)
        //     await dataBkkbn.local.bulkDocs(pkQuery.docs.map(doc => ({ ...doc, _deleted: true })))

        enqueueSnackbar("Data berhasil dihapus", { variant: "success" });

        // getAllDataBkkbn();
        // getAllDataBkkbnServer();

        let id = _id;

        let userDelete = metadata.name;
        let userDataDelete = 9;

        fetch("https://webpushnotif-dev.bkkbn.go.id/api/v1/pushnotification", {
          // fetch('https://webpushnotif.bkkbn.go.id/api/v1/pushnotification', {
          // fetch('http://dev-web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            _id: id,
            username: userDelete,
            statusData: userDataDelete,
          }),
        })
          .then((respone) => {
            respone.json();
          })
          .then((data) => {})
          .catch((e) => console.error(e));

        setTimeout(() => {
          window.location.reload();
        }, 3500);
      } else {
        enqueueSnackbar("Gagal menghapus data", { variant: "error" });
      }
    } catch (e) {
      console.log(e);
      enqueueSnackbar("Gagal menghapus data: " + e.message, {
        variant: "error",
      });
    }
    setDeleting(false);
  };

  const DeleteDialog = () => {
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Yakin menghapus data ini?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Setelah dihapus data <b> {forDelete.name} </b> akan hilang dari
              daftar keluarga
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Batal
            </Button>
            <Button onClick={deleteKel(forDelete.id)} color="primary" autoFocus>
              Ya
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const handleClickDelete = (id, name) => async (e) => {
    const data = {
      id: id,
      name: name,
    };
    setDelete(data);
    setOpen(true);
  };

  if (isFetching) {
    return <AppPageLoading />;
  }

  const handleEdit = (id) => async (e) => {
    if (lock == "true") {
      alert("Tidak tersedia untuk saat ini");
    } else {
      history.push(`form/edit/${id}`);
    }
  };

  const handleSensus = async (event) => {
    const { value } = event.target;
    setStatusSensus((oldValue) => (oldValue === value ? oldValue : value));
    if (value === "all") {
      const getAllDataBkkbn = async () => {
        const query = await dataBkkbn.local.find({
          selector: {
            user_name: { $eq: metadata.name },
          },
        });

        const newDocs = [];
        query.docs.forEach((item) => {
          if (item.status_draft && item.status_draft === "1") {
            newDocs.push(item);
          }
        });

        setDataBkkbnDocs(newDocs);
      };
      getAllDataBkkbn();
    } else {
      const query = await dataBkkbn.local.find({
        selector: {
          user_name: { $eq: metadata.name },
          status_sensus: event.target.value,
        },
      });
      const newDocs = [];
      query.docs.forEach((item) => {
        if (item.status_draft && item.status_draft === "1") {
          newDocs.push(item);
        }
      });

      setDataBkkbnDocs(newDocs);
    }
  };

  return (
    <Container maxWidth="md" className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.textCenter}>
          <Typography variant="h5" component="h1">
            Daftar Draft
          </Typography>
        </Grid>
        <Grid item xs={6} md={3} lg={3} className={classes.textLeft}>
          <FormControl variant="outlined" fullWidth>
            {/* <Select
                            id="sts_hubungan"
                            value={statusSensus}
                            name="status_sensus"
                            onChange={handleSensus}
                            displayEmpty
                        >
                            <MenuItem value=""> Status </MenuItem>
                            <MenuItem value="all"> All </MenuItem>
                            <MenuItem value="Valid"> Valid </MenuItem>
                            <MenuItem value="NotValid"> NotValid </MenuItem>
                            <MenuItem value="Anomali"> Anomali </MenuItem>
                        </Select> */}
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        {kepalaKels.length <= 0 && (
          <Grid item xs={12} className={classes.textCenter}>
            <Typography>Data tidak ditemukan!</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <List>
            {kepalaKels.map((kepala, index) => {
              let no = index + 1;
              let trim = kepala._id;
              // let id = trim.substring(0, 13)
              let id = trim;

              return (
                <ListItem divider key={kepala._id}>
                  {/* {
                                    statusSensus == "valid" &&
                                } */}
                  <ListItemText
                    primary={no + ". " + kepala.nama_anggotakel}
                    // secondary={`NIK.${kepala.nik}
                    // Status Sensus.${kepala.status_sensus}`}
                    secondary={
                      <div>
                        <div>{`NIK:${kepala.nik}`}</div>
                        <div>{`Status: ${kepala.status_sensus}`}</div>
                      </div>
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      disabled={isDeleting}
                      // component={Link} to={`form/edit/${id}`} edge="end" aria-label="edit"
                      onClick={handleEdit(id)}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      disabled={isDeleting}
                      edge="end"
                      aria-label="delete"
                      onClick={handleClickDelete(
                        kepala._id,
                        kepala.nama_anggotakel
                      )}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </Grid>
      </Grid>

      <DeleteDialog />
    </Container>
  );
}

export default Draft;
